/**
 * @generated SignedSource<<4e918fc8e473427ef7e743fe03b44bcb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RewardForm_TreeNodeFragment$data = {
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"EditAwardPacPointsConfigurationForm_TreeNodeFragment" | "EditAwardPharmaPointsConfigurationForm_TreeNodeFragment" | "EmailRewardConfigurationForm_TreeNodeFragment">;
  readonly " $fragmentType": "RewardForm_TreeNodeFragment";
};
export type RewardForm_TreeNodeFragment$key = {
  readonly " $data"?: RewardForm_TreeNodeFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"RewardForm_TreeNodeFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RewardForm_TreeNodeFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EmailRewardConfigurationForm_TreeNodeFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EditAwardPacPointsConfigurationForm_TreeNodeFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EditAwardPharmaPointsConfigurationForm_TreeNodeFragment"
    }
  ],
  "type": "TreeNode",
  "abstractKey": null
};

(node as any).hash = "24b232f4392b55b3d185506f8f2d792a";

export default node;
